import { combineReducers } from 'redux'
import {
  SELECT_JOB,
  INVALIDATE_JOB,
  REQUEST_POSTS,
  RECEIVE_POSTS
} from './actions'

function selectedJob(state = 'All', action) {
  switch (action.type) {
    case SELECT_JOB:
      return action.job
    default:
      return state
  }
}

function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
	action,
	searchText,
	keyword
) {
	switch (action.type) {
		case INVALIDATE_JOB:
		return Object.assign({}, state, {
			didInvalidate: true
		})
    case REQUEST_POSTS:
		return Object.assign({}, state, {
			isFetching: true,
			didInvalidate: false
		})
    case RECEIVE_POSTS:
			const searchTextLowered = action.searchText.toLowerCase();
			let humanKeyword = action.keyword.split('-').join(" ");
			let jobOptions = ["All", "java", ".net", "c#", "customer support", "mysql", "css", "api", "senior", "intern", "sql", "consultant", "go", "teacher", "data entry", "react", "marketing", "node", "angular", "vue", "javascript", "Customer Service", "sales", "manager", "blockchain", "medical", "analyst", "designer", "seo", "writer", "quality assurance", "devops", "support engineer", "full stack", "machine learning"];
			if (!jobOptions.includes(humanKeyword) || humanKeyword === "All") {
				humanKeyword = '';
			}
			return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
				items: action.posts.filter((job) => {
					if (job.title) {
						if (!job.description) {
							return job.title.toLowerCase().includes(humanKeyword) && job.title.toLowerCase().includes(searchTextLowered)
						} else {
							return job.description.toLowerCase().includes(humanKeyword) && job.description.toLowerCase().includes(searchTextLowered);
						}
					} else if (job.position) {
						if (!job.description) {
							return job.position.toLowerCase().includes(humanKeyword) && job.position.toLowerCase().includes(searchTextLowered)
						} else {
							return job.description.toLowerCase().includes(humanKeyword) && job.description.toLowerCase().includes(searchTextLowered);
						}
					}
					return '';
				}),
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

function postsByJob(state = {}, action, searchText, keyword) {
  switch (action.type) {
    case INVALIDATE_JOB:
    case RECEIVE_POSTS:
		case REQUEST_POSTS:
		// let obj = posts(state[action.job], action);
      return Object.assign({}, state, {
        [action.job]: posts(state[action.job], action)
      })
    default:
      return state
  }
}

const rootReducer = combineReducers({
  postsByJob,
  selectedJob
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers.js